export default __webpack_public_path__ + "static/media/avatar3.bc184f53.png";